import { PageSelectUl } from './StyledElements.jsx'
import { langPageSelect } from '../assets/langPageSelect'
import { useLang, useMobile } from '../utils/hooks.jsx'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'

const PageSelect = ({
  handleClickSelectPage,
  list,
  itemsPerPage,
  buttonsActive,
}) => {
  const { mobile } = useMobile()
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langPageSelect.fr : langPageSelect.eng
  const totalItems = list.totalItems
  const selectedPage = list.selectedPage
  const filtered = list.searchInput !== '' ? list.initialData.length : 0

  const on_click_select_page = (event) => {
    handleClickSelectPage(event.target.id)
  }

  const gotoPreviousPage = () => {
    handleClickSelectPage(selectedPage - 1)
  }

  const gotoNextPage = () => {
    handleClickSelectPage(selectedPage + 1)
  }

  const start_elts =
    totalItems > 0 ? (selectedPage - 1) * itemsPerPage + 1 : totalItems
  const end_elts =
    selectedPage * itemsPerPage > totalItems
      ? totalItems
      : selectedPage * itemsPerPage
  const filter_info =
    filtered !== 0
      ? ' (' +
        choosenLang.filteredFrom +
        filtered +
        choosenLang.filteredTo +
        ')'
      : ''
  const infos =
    choosenLang.display1 +
    start_elts +
    choosenLang.display2 +
    end_elts +
    choosenLang.display3 +
    totalItems +
    choosenLang.display4 +
    filter_info
  const number_of_pages =
    Math.trunc(totalItems / itemsPerPage) +
    (totalItems % itemsPerPage !== 0 ? 1 : 0)

  const links = []

  links.push(
    <p className="control" key="prev">
      <button
        className="button is-light is-small pr-1 pl-1"
        onClick={gotoPreviousPage}
        disabled={selectedPage === 1 || !buttonsActive}
      >
        {/* {choosenLang.displayPrevious} */}
        <FaChevronLeft />
      </button>
    </p>,
  )
  /* } */

  if (number_of_pages > 0) {
    let i = 1

    links.push(
      <p className="control" key={i}>
        <button
          id={i}
          className={
            'button pr-1 pl-1 ' +
            (selectedPage === 1 ? 'is-primary is-light ' : 'is-light ') +
            'is-small'
          }
          onClick={on_click_select_page}
          disabled={selectedPage === 1 || !buttonsActive}
        >
          {i}
        </button>
      </p>,
    )

    if (selectedPage <= 5) {
      i = 2
      while (i <= 5 && i < number_of_pages) {
        links.push(
          <p className="control" key={i}>
            <button
              id={i}
              className={
                'button  pr-1 pl-1 ' +
                (selectedPage === i ? 'is-primary is-light ' : 'is-light ') +
                'is-small'
              }
              onClick={on_click_select_page}
              disabled={selectedPage === i || !buttonsActive}
            >
              {i}
            </button>
          </p>,
        )
        i++
      }
      if (number_of_pages > 5) {
        links.push(
          <p className="control" key="blank1">
            <button
              className="button is-white is-small pr-1 pl-1"
              disabled={true}
            >
              {'...'}
            </button>
          </p>,
        )
      }
    } else if (selectedPage < number_of_pages - 3) {
      links.push(
        <p className="control" key="blank2">
          <button
            className="button is-white is-small pr-1 pl-1"
            disabled={true}
          >
            {'...'}
          </button>
        </p>,
      )

      let p = 1
      i = selectedPage - 1
      while (i <= number_of_pages && p <= 3) {
        links.push(
          <p className="control" key={i}>
            <button
              id={i}
              className={
                'button pr-1 pl-1 ' +
                (selectedPage === i ? 'is-primary is-light ' : 'is-light ') +
                'is-small'
              }
              onClick={on_click_select_page}
              disabled={selectedPage === i || !buttonsActive}
            >
              {i}
            </button>
          </p>,
        )
        p++
        i++
      }
      if (number_of_pages > 5)
        links.push(
          <p className="control" key="blank3">
            <button
              className="button is-white is-small pr-1 pl-1"
              disabled={true}
            >
              {'...'}
            </button>
          </p>,
        )
    } else {
      links.push(
        <p className="control" key="blank4">
          <button
            className="button is-white is-small pr-1 pl-1"
            disabled={true}
          >
            {'...'}
          </button>
        </p>,
      )
      i = number_of_pages - 4
      while (i < number_of_pages) {
        links.push(
          <p className="control" key={i}>
            <button
              id={i}
              className={
                'button pr-1 pl-1 ' +
                (selectedPage === i ? 'is-primary is-light ' : 'is-light ') +
                'is-small'
              }
              onClick={on_click_select_page}
              disabled={selectedPage === i || !buttonsActive}
            >
              {i}
            </button>
          </p>,
        )
        i++
      }
    }
    if (number_of_pages > 1)
      links.push(
        <p className="control" key={number_of_pages}>
          <button
            id={number_of_pages}
            className={
              'button pr-1 pl-1 ' +
              (selectedPage === i ? 'is-primary is-light ' : 'is-light ') +
              'is-small'
            }
            onClick={on_click_select_page}
            disabled={selectedPage === i || !buttonsActive}
          >
            {number_of_pages}
          </button>
        </p>,
      )
  }

  links.push(
    <p className="control" key="next">
      <button
        className="button is-light is-small pr-1 pl-1"
        onClick={gotoNextPage}
        disabled={selectedPage === number_of_pages || !buttonsActive}
      >
        {/* {choosenLang.displayNext} */}
        <FaChevronRight />
      </button>
    </p>,
  )

  return (
    list.totalItems > 0 && (
      <>
        {mobile ? (
          <div className="tag is-warning is-light mb-1">{infos}</div>
        ) : null}
        <PageSelectUl mobile={mobile}>
          {!mobile ? (
            <div className="tag is-warning is-light mb-1">{infos}</div>
          ) : null}
          <div className="field is-grouped">{links}</div>
        </PageSelectUl>
      </>
    )
  )
}

export default PageSelect
